import React from "react";
import Sidebar from "./sidebar";
import Header from "./header";
import Footer from "./footer";
import "../assets/css/animate.min.css";
import "../assets/css/animation.css";
import "../assets/css/bootstrap-select.min.css";
import "../assets/css/style.css";
import "../assets/font/fonts.css";
import "../assets/icon/style.css";

const Layout = ({ children }) => {
  return (
    <div className="layout-wrap">
      <Sidebar />
      <div className="section-content-right">
        <Header />
        <div className="main-content">
          {children}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;
